import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";
export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    user: null
  },
  getters: {
    getUser: state => {
      return state.user;
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    }
  },
  actions: {
    setUser(context, user) {
      context.commit("setUser", user);
    },
    signOut() {
      firebase.auth().signOut();
    }
  }
});
